<template>
  <div>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>

      <form-group label="Tipo de preço" :columns="6">
        <select v-model="filters.price.type" class="form-select">
          <option :value=null>Todos</option>
          <option value="source">Preço Módulo</option>
          <option value="custom">Customizado</option>
          <option value="percent">Percentual sobre preço de venda</option>
          <option value="fixed">Valor fixo sobre preço de venda</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      brands: [],
      filters: {
        brand: null,
        price: {
          type: null
        }
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getBrands(this.module.type, this.module.identifier)
        .then(brands => { this.brands = brands })
        .catch(() => (this.brands = []))
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Carrefour.vue?56eba49e